<template>
  <div class="docs-sidebar-container">
    <sidebar-view
      ref="sidebar"
      item-key-field="name"
      :list="itemsList"
      :common-actions="commonActions"
      :item-actions="itemActions"
      @common-action='onCommonAction'
      @item-action='onItemAction'
    ></sidebar-view>
    <doc-name-dialog
      ref="dialog"
      v-model="currentDocName"
      @confirm="performDocCreate"
    ></doc-name-dialog>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'

export default {
  name: 'DocsSidebarContainer',
  components: {
    SidebarView: require('./SidebarView'),
    DocNameDialog: require('@/components/DocNameDialog.vue')
  },
  computed: {
    ...mapState({
      docs: state => state.docs
    }),
    itemsList () {
      return this.docs.map((doc) => ({
        name: doc.name
      }))
    }
  },
  methods: {
    ...mapActions(['loadDoc', 'createDoc']),
    open () {
      this.$refs.sidebar.toggleExpandState(true)
    },
    close () {
      this.$refs.sidebar.toggleExpandState(false)
    },
    performDocCreate () {
      this.createDoc(this.currentDocName)
      this.loadDoc(this.currentDocName)
    },
    onCommonAction (actionKey) {
      if (actionKey === 'create') {
        this.$refs.dialog.open()
      }
    },
    onItemAction (actionKey, item) {
      if (actionKey === 'open') {
        this.loadDoc(item.name)
        this.close()
      }
    }
  },
  data () {
    return {
      currentDocName: '',
      itemActions: [
        {
          key: 'open',
          name: 'Открыть',
          icon: 'open_in_browser'
        },
        {
          key: 'delete',
          name: 'Удалить',
          icon: 'delete'
        }
      ],
      commonActions: [
        {
          key: 'create',
          name: 'Новый документ',
          icon: 'add_box'
        }
      ]
    }
  }
}
</script>


// WEBPACK FOOTER //
// DocsSidebarContainer.vue?1feb1d78